import { useQuery } from "react-query";
import type { PartnerDto } from "common/models/api/models/PartnerDto";
import { Queries } from "ui/query/queries";
import type { QueryResult } from "ui/query/react-query-overrides";
import { partnersApi } from "../api/partnersApi";

export interface UseGetPartnerParams {
    address?: string;
}

export default function useGetPartner({ address }: UseGetPartnerParams): QueryResult<PartnerDto> {
    const safeAddress = address as string;

    return useQuery(
        [Queries.PARTNER, address],
        async () => {
            const res = await partnersApi.findByAddress(safeAddress);
            return res.data;
        },
        { enabled: address !== undefined },
    );
}
